import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadApplicationListBegin, loadApplicationListFailed, loadApplicationListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY,
} from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadApplicationList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    const pool = {
      limit,
      page,
      include: 'registrySubject,executor,creator,documents,files,worstCheck',
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      // pool.filter = addFilterQueryWithCondition(filter);
      pool.filter = addFilterQuery(filter);
    }
    // if (typeof sort === 'string' && sort.length) {
    //   pool = { ...pool, sort };
    // }
    const url = `${BACKEND_URL}/proxy/backend/api/v2/applications/search`;
    yield put(loadApplicationListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadApplicationListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadApplicationListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadApplicationListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
